export class NotAuthenticated extends Error {}
